<template>
  <b-card-text>
    <b-row class="mb-1">
      <b-col md="6" sm="12">
        <b-button @click="add()" type="button" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Agregar Whatsapp">
          <i class="fa fa-plus"></i> Agregar
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mb-3">
      <b-col md="6" sm="12">
        <b-table class="mb-0"
                responsive="sm"
                head-variant="dark"
                :hover="true"
                :small="true"
                :fixed="false"
                :items="table.items"
                :fields="table.fields"
                :filter="table.filter"
                :current-page="table.currentPage"
                :per-page="table.perPage"
                v-if="table.items.length">

          <template v-slot:cell(id)="data">
            <b>{{ data.item.id }}</b>
          </template>

          <template v-slot:cell(active)="data">
            <div v-if="data.item.active">
              <b-badge variant="success">Activo</b-badge>
            </div>
            <div v-else>
              <b-badge variant="danger">Inactivo</b-badge>
            </div>
          </template>

          <template v-slot:cell(templates_count)="data">
            <span class="templates-count-value">{{ activeTemplatesCount(data.item) }}</span>
          </template>

          <template v-slot:cell(webhook)="data">
            <b-button size="sm" variant="outline-secondary" v-b-tooltip.hover title="Copiar URL del Webhook" @click="copyWebhookUrl(data.item.id)">
              <b-icon icon="clipboard"></b-icon>
            </b-button>
          </template>

          <template v-slot:cell(f_action)="data">
            <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">
              <b-dropdown-item @click="testConnection(data.item)" v-if="data.item.phone_number_id && data.item.access_token">
                <b-icon icon="plug"></b-icon> Probar Conexión
              </b-dropdown-item>
              <b-dropdown-item @click="openTemplates(data.item)" v-if="data.item.active && data.item.waba_id">
                <b-icon icon="file-earmark-text"></b-icon> Plantillas
              </b-dropdown-item>
              <b-dropdown-header>Acciones</b-dropdown-header>
              <b-dropdown-item @click="edit(data.item)">
                <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
              </b-dropdown-item>
              <b-dropdown-item @click="remove(data.item)">
                <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
      </b-col>
      <b-col md="6" sm="12">
        <b-card bg-variant="light" header="Implementación" text-variant="dark">
          <b-card-text>
            Las notificaciones vía WhatsApp se implementan a través de la
            <a href="https://developers.facebook.com/docs/whatsapp/cloud-api" target="_blank">WhatsApp Cloud API</a> oficial de Meta.
            Hay dos formas de conectarse, según si ya tenés o no una cuenta de negocio verificada en Meta.

            <hr>

            <div class="mb-2">
              <b-badge variant="warning" class="mr-2">MODO PRUEBA</b-badge>
              <span class="text-muted">gratis, sin verificar el negocio — ideal para probar la integración</span>
            </div>

            <ol class="pl-3 mb-2">
              <li>Entrá a <a href="https://developers.facebook.com/apps" target="_blank">developers.facebook.com/apps</a> y creá una App tipo <b>"Business"</b>.</li>
              <li>Dentro de la App, agregá el producto <b>WhatsApp</b> ("Set up"). Te lleva a <b>WhatsApp → API Setup</b>, donde ya tenés sin configurar nada más:
                <ul class="pl-3">
                  <li>Un número de prueba de Meta (ej. "+1 555 xxx xxxx").</li>
                  <li>El <b>Phone Number ID</b> (cargalo tal cual en el campo de abajo).</li>
                  <li>Un <b>Temporary access token</b>, válido 24hs (cargalo en "Access Token" para probar ya).</li>
                </ul>
              </li>
              <li>Para poder <b>recibir</b> los mensajes de prueba, en esa misma pantalla, sección "To", abrí "Manage phone number list", agregá tu celular con código de país y confirmá el código que llega por WhatsApp.
                <br>Podés cargar hasta <b>5 números</b>. En modo prueba <b>solo</b> se puede mandar mensajes a estos números verificados.
              </li>
            </ol>

            <b-alert show variant="secondary" class="py-2 px-3 small mb-2">
              <b-icon icon="clock-history" class="mr-1"></b-icon>
              El token temporal expira a las 24hs. Para uno de 60 días sin necesidad de verificar el negocio: en
              <a href="https://business.facebook.com/settings/system-users" target="_blank">Business Settings → System Users</a>,
              creá un usuario de sistema, asignale la App con control total, y generá un token con el permiso <code>whatsapp_business_messaging</code>.
            </b-alert>

            <hr>

            <div class="mb-2">
              <b-badge variant="success" class="mr-2">MODO REAL (PRODUCCIÓN)</b-badge>
              <span class="text-muted">para enviar a cualquier destinatario, sin lista de verificados</span>
            </div>

            <ol class="pl-3 mb-2">
              <li>En la misma App, andá a <b>Meta Business Suite → Business Settings</b> y completá la
                <a href="https://www.facebook.com/business/help/2058515294227817" target="_blank">verificación del negocio</a> (datos legales de la empresa, puede tardar unos días).
              </li>
              <li>En <b>WhatsApp → API Setup</b>, agregá tu <b>número de teléfono real</b> (el que usarán tus clientes para identificarte). Ese número no puede estar activo en la app de WhatsApp normal ni Business al mismo tiempo.</li>
              <li>Generá el <b>token permanente</b> con el usuario de sistema (ver recuadro arriba) — reemplazá el temporal por este en el campo "Access Token".</li>
              <li>Cargá el <b>WABA ID</b> (WhatsApp Business Account ID, visible en API Setup) para poder dar de alta <b>Plantillas</b> desde este mismo listado.</li>
            </ol>

            <b-alert show variant="warning" class="py-2 px-3 small mb-0">
              <b-icon icon="exclamation-triangle" class="mr-1"></b-icon>
              Fuera de una conversación iniciada por el cliente en las últimas 24hs, Meta <b>solo permite enviar Plantillas aprobadas</b>
              (no mensajes de texto libre). Por eso, para avisos proactivos (recordatorios, confirmaciones, etc.) armá y validá una
              plantilla desde el botón <b>"Plantillas"</b> de este listado.
            </b-alert>

            <hr>

            El <b>Verify Token</b> es una palabra que vos elegís acá — la misma que después cargás en la configuración del Webhook dentro de Meta
            (<a href="https://developers.facebook.com/docs/whatsapp/cloud-api/guides/set-up-webhooks" target="_blank">guía de Meta para configurar el Webhook</a>).
            Esto aplica igual en modo prueba y en modo real.
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
                          
    <b-row>
      <b-col>
        <nav>
          <b-pagination class="pull-right mb-0"
                        size="sm"
                        pills=""
                        :total-rows="getRowCount(table.items)"
                        :per-page="table.perPage"
                        v-model="table.currentPage" />
        </nav>
      </b-col> 
    </b-row>            

    <!-- ########################### -->
    <!-- #####     MODALES     ##### -->
    <!-- ########################### -->

    <b-modal v-model="modal.form.active"
            header-bg-variant="dark"
            header-text-variant="white"
            :key="modal.form._id"
            :id="modal.form._id">                
      <div slot="modal-header" minimize>
        {{this.modal.form.title}}
      </div>

      <b-row>
        <b-col md="12">
          <b-form-group label="Referencia">
            <b-form-input type="text"
                          size="sm"
                          v-model="crud.form.name"
                          required>
            </b-form-input>
          </b-form-group>
        </b-col>                    
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="Phone Number ID">
            <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.phone_number_id"
                            required>
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="WABA ID" description="WhatsApp Business Account ID — necesario para dar de alta plantillas">
            <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.waba_id">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="Access Token">
            <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.access_token"
                            required>
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="Verify Token" description="Palabra clave a configurar también en el Webhook de Meta">
            <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.verify_token"
                            required>
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="crud.form.id">
        <b-col md="12">
          <b-form-group label="Webhook URL" description="Pegala tal cual en Meta: App → WhatsApp → Configuration → Webhook → Callback URL">
            <b-input-group size="sm">
              <b-form-input type="text"
                            size="sm"
                            :value="webhookUrl(crud.form.id)"
                            readonly>
              </b-form-input>
              <b-input-group-append>
                <b-button variant="secondary" size="sm" @click="copyWebhookUrl(crud.form.id)">
                  <b-icon icon="clipboard"></b-icon>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col md="12">
          <b-alert show variant="secondary" class="py-2 px-3 small mb-0">
            Guardá el registro para obtener la URL del Webhook.
          </b-alert>
        </b-col>
      </b-row>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
        <b-button variant="dark" @click="save()">Guardar</b-button>
      </div>
    </b-modal>
  
    <!-- MODAL TEST -->
    <b-modal v-model="modal.formTest.active"
            header-bg-variant="dark"
            header-text-variant="white">

      <div slot="modal-header">
        {{this.modal.formTest.title}}
      </div>

      <b-row>
        <b-col md="12">
          <b-form-group label="Referencia">
            <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            disabled>
            </b-form-input>
          </b-form-group>
        </b-col>                    
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="Phone Number ID">
            <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.phone_number_id"
                            disabled>
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="Access Token">
            <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.access_token"
                            disabled>
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="12">
          <b-form-group label="Télefono de Prueba" description="Debe ser uno de los números verificados como destinatario de prueba en tu Meta App. Podés escribirlo con o sin el 9 de móvil, lo ajustamos automáticamente.">
            <b-form-input type="number"
                          size="sm"
                          v-model="crud.form.nroTest"
                          placeholder="Cod país [sin el signo] + cod área [sin el 0] + nro cel [sin el 15]">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="modal.formTest.active=false">Cancelar</b-button>
        <b-button variant="dark" @click="testWhatsapp()">Probar Conexión</b-button>
      </div>
    </b-modal>

    <!-- MODAL PLANTILLAS -->
    <b-modal v-model="modal.templates.active"
            header-bg-variant="dark"
            header-text-variant="white"
            size="lg"
            no-close-on-backdrop>

      <div slot="modal-header">
        Plantillas — {{ modal.templates.whatsappName }}
      </div>

      <b-row class="mb-2">
        <b-col md="4">
          <b-form-group label="Filtrar por estado">
            <b-form-select v-model="table.templates.filterStatus" :options="arr.select.templateStatusFilter"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-table class="mb-0"
              responsive="sm"
              head-variant="dark"
              :hover="true"
              :small="true"
              :fixed="false"
              :items="filteredTemplates"
              :fields="table.templates.fields"
              v-if="filteredTemplates.length">

        <template v-slot:cell(body)="data">
          <span :title="data.item.body">{{ data.item.body }}</span>
        </template>

        <template v-slot:cell(status)="data">
          <b-badge :variant="statusVariant(data.item.status)">{{ data.item.status }}</b-badge>
          <div v-if="data.item.status == 'REJECTED' && data.item.rejected_reason" class="small text-danger mt-1">
            {{ data.item.rejected_reason }}
          </div>
        </template>

        <template v-slot:cell(f_action)="data">
          <b-button size="sm" variant="dark" class="mr-1" @click="validateTemplate(data.item)">
            Enviar a validar
          </b-button>
          <b-button size="sm" variant="outline-secondary" @click="refreshTemplateStatus(data.item)" v-if="data.item.meta_template_id">
            Actualizar estado
          </b-button>
        </template>
      </b-table>
      <b-alert v-else variant="warning" show>No se encontraron plantillas</b-alert>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" @click="modal.templates.active=false">Cerrar</b-button>
      </div>
    </b-modal>

  </b-card-text>
</template>

<script>
  import serviceAPI from './../services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Funciones from '@/handler/funciones'
  import ConfigAPI from '@/config/api'

  export default {
    data: () => {
      return {      
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', sortable: true, class:"align-middle"},
            {key: 'name', label: 'Referencia', class:"align-middle"},
            {key: 'phone_number_id', label: 'Phone Number ID', class:"align-middle"},
            {key: 'verify_token', label: 'Verify Token', class:"align-middle"},
            {key: 'active', label: 'Activo', class:"align-middle text-center"},
            {key: 'templates_count', label: 'Plantillas Activas', class:"align-middle text-center"},
            {key: 'webhook', label: 'Webhook', class:"align-middle text-center"},
            {key: 'f_action', label:'', class:"align-middle"},
          ],
          currentPage: 1,
          perPage: 50,
          templates: {
            items: [],
            filterStatus: '',
            fields: [
              {key: 'name', label: 'Nombre', class:"align-middle"},
              {key: 'category', label: 'Categoría', class:"align-middle text-center"},
              {key: 'body', label: 'Mensaje', class:"align-middle"},
              {key: 'status', label: 'Estado', class:"align-middle text-center"},
              {key: 'f_action', label:'', class:"align-middle text-right"},
            ],
          },
        },
        crud: {
          form: {
            id: 0,
            name: '',
            phone_number_id: '',
            waba_id: '',
            access_token: '',
            verify_token: '',
            nroTest: '',
          },
        },
        arr: {
          select: {
            templateStatusFilter: [
              { value: '', text: 'Todas' },
              { value: 'active', text: 'Activas' },
              { value: 'inactive', text: 'No activas' },
            ],
          }
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
          formTest: {
            active: false,
            title: ''
          },
          templates: {
            active: false,
            whatsappId: 0,
            whatsappName: '',
          },
        },
      }
    },
    computed: {
      filteredTemplates() {
        if(this.table.templates.filterStatus == 'active') {
          return this.table.templates.items.filter((item) => item.status == 'APPROVED')
        }
        if(this.table.templates.filterStatus == 'inactive') {
          return this.table.templates.items.filter((item) => item.status != 'APPROVED')
        }
        return this.table.templates.items
      }
    },
    mounted () {
      this.show()
      this.loadTemplates()
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      show() {        
        var result = serviceAPI.obtenerWhatsapp()

        result.then((response) => {
          var data = response.data
          this.table.items = data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });  
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.phone_number_id = ''
        this.crud.form.waba_id = ''
        this.crud.form.access_token = ''
        this.crud.form.verify_token = ''

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Whatsapp"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.phone_number_id = item.phone_number_id
        this.crud.form.waba_id = item.waba_id
        this.crud.form.access_token = item.access_token
        this.crud.form.verify_token = item.verify_token

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Whatsapp"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.phone_number_id = item.phone_number_id
        this.crud.form.access_token = item.access_token

        this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Whatsapp',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarWhatsapp(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.show()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarWhatsapp(this.crud.form);
        } else {
          var result = serviceAPI.agregarWhatsapp(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.show()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      testConnection(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.phone_number_id = item.phone_number_id
        this.crud.form.access_token = item.access_token
        this.crud.form.nroTest = ''

        this.modal.formTest.title = "Probar Conexión"
        this.modal.formTest.active = true
      },
      testWhatsapp() {
        if(!Funciones.validarTelefonoWhatsapp(this.crud.form.nroTest)) {
          this.$awn.alert("No se puede realizar el test sino se ingresa un nro de teléfono válido (con o sin el 9 de móvil)")
          return false
        }
        this.$bvModal.msgBoxConfirm('¿Probar configuración de whatsapp?', {
          title: 'Configuración de whatsapp',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'PROBAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: "dark",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {   
            let loader = this.$loading.show();
            var result = serviceAPI.testWhatsapp(this.crud.form)

            result.then((response) => {
              this.modal.formTest.active = false
              loader.hide()
              this.show()   
              this.$awn.success('Conexión en funcionamiento!!')              
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            });
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      openTemplates(item) {
        this.modal.templates.whatsappId = item.id
        this.modal.templates.whatsappName = item.name
        this.table.templates.filterStatus = ''

        this.loadTemplates()
        this.modal.templates.active = true
      },
      loadTemplates() {
        var result = serviceAPI.listWhatsappTemplates()

        result.then((response) => {
          this.table.templates.items = response.data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        })
      },
      statusVariant(status) {
        var map = { DRAFT: 'secondary', PENDING: 'warning', APPROVED: 'success', REJECTED: 'danger', PAUSED: 'dark', DISABLED: 'dark' }
        return map[status] || 'secondary'
      },
      validateTemplate(template) {
        this.$bvModal.msgBoxConfirm('¿Enviar la plantilla "' + template.name + '" a validar con "' + this.modal.templates.whatsappName + '"?', {
          title: 'Enviar a validar',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'ENVIAR',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: "dark",
          headerTextVariant: "white",
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.validateWhatsappTemplate(template.id, this.modal.templates.whatsappId)

            result.then((response) => {
              loader.hide()
              this.loadTemplates()
              this.$awn.success("Plantilla enviada a validar")
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error))
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      refreshTemplateStatus(template) {
        let loader = this.$loading.show();
        var result = serviceAPI.refreshWhatsappTemplateStatus(template.id)

        result.then((response) => {
          loader.hide()
          this.loadTemplates()
          this.$awn.success("Estado actualizado")
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        })
      },

      activeTemplatesCount(item) {
        return this.table.templates.items.filter((template) => {
          return template.notifications_whatsapp_id == item.id && template.status == 'APPROVED'
        }).length
      },
      webhookUrl(id) {
        return ConfigAPI.baseURL + 'notifications/whatsapp/' + id + '/webhooks'
      },
      copyWebhookUrl(id) {
        var url = this.webhookUrl(id)

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url)
            .then(() => this.$awn.success('Webhook copiado al portapapeles'))
            .catch(() => this.$awn.alert('No se pudo copiar. Copialo manualmente: ' + url))
        } else {
          this.$awn.alert('No se pudo copiar. Copialo manualmente: ' + url)
        }
      },
    }
  }
</script>

<style scoped>
  .templates-count-value {
    font-size: 1.15rem;
    font-weight: 700;
    color: #2c3e50;
  }
</style>